// Az ügyfél-detail SZEKCIÓ-AZONOSÍTÓI — egy helyen, mert KÉT fél használja őket, és ha elcsúsznak,
// a ragadós navigáció némán nem talál célt (nem hibázik, csak nem ugrik sehova):
//   • a szekció-komponensek (`FormSection id=…`) — a horgony,
//   • a `clients.$id` route — a `SectionNav` elemei.
// A `SECTION_IDS` a rail SORRENDJÉT is rögzíti: azonos a lap DOM-sorrendjével (és a létrehozás-oldali
// zárolt szekciók sorrendjével), különben a rail más sorrendet sugallna, mint amit a felhasználó görget.
export const CLIENT_SECTION = {
  data: 'client-data',
  accounts: 'client-accounts',
  services: 'client-services',
  paymentCards: 'client-payment-cards',
  billingProfiles: 'client-billing-profiles',
  danger: 'client-danger',
} as const;
